<template>
    <div class="wrapper">
        <el-breadcrumb separator-class="el-icon-arrow-right" style="margin: 4.8vw 7.733vw;">
            <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
            <el-breadcrumb-item>Company profile</el-breadcrumb-item>
        </el-breadcrumb>
        <el-carousel indicator-position="none" :autoplay="false" height="56.267vw" :loop="false">
            <el-carousel-item v-for="(item, index) in Images" :key="index">
                <img style="width: 100%; object-fit: cover;" v-lazy="item.imgPath" />
            </el-carousel-item>
        </el-carousel>
        <div class="down">
            <el-button type="danger" @click="downloadPdf" :disabled="isDownloading" round>Download PDF</el-button>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            pdfBlob: null,
            isDownloading: false,
            Images: [
                { imgPath: require('../assets/imgs/company/1-01.jpg') },
                { imgPath: require('../assets/imgs/company/1-02.jpg') },
                { imgPath: require('../assets/imgs/company/1-03.jpg') },
                { imgPath: require('../assets/imgs/company/1-04.jpg') },
                { imgPath: require('../assets/imgs/company/1-05.jpg') },
                { imgPath: require('../assets/imgs/company/1-06.jpg') },
                { imgPath: require('../assets/imgs/company/1-07.jpg') },
                { imgPath: require('../assets/imgs/company/1-08.jpg') },
                { imgPath: require('../assets/imgs/company/1-09.jpg') },
                { imgPath: require('../assets/imgs/company/1-10.jpg') },
                { imgPath: require('../assets/imgs/company/1-11.jpg') },
                { imgPath: require('../assets/imgs/company/1-12.jpg') },
                { imgPath: require('../assets/imgs/company/1-13.jpg') },
                { imgPath: require('../assets/imgs/company/1-14.jpg') },
                { imgPath: require('../assets/imgs/company/1-15.jpg') },
                { imgPath: require('../assets/imgs/company/1-16.jpg') },
                { imgPath: require('../assets/imgs/company/1-17.jpg') },
                { imgPath: require('../assets/imgs/company/1-18.jpg') },
                { imgPath: require('../assets/imgs/company/1-19.jpg') },
                { imgPath: require('../assets/imgs/company/1-20.jpg') },
                { imgPath: require('../assets/imgs/company/1-21.jpg') },
                { imgPath: require('../assets/imgs/company/1-22.jpg') },
                { imgPath: require('../assets/imgs/company/1-23.jpg') },
                { imgPath: require('../assets/imgs/company/1-24.jpg') },
                { imgPath: require('../assets/imgs/company/1-25.jpg') },
                { imgPath: require('../assets/imgs/company/1-26.jpg') },
            ],
        };
    },
    methods: {
        async preloadPdf() {
            const response = await fetch('/Companyprofile.pdf');
            if (response.ok) {
                this.pdfBlob = await response.blob();
            }
        },
        downloadPdf() {
            if (this.pdfBlob) {
                this.isDownloading = true;
                this.$notify.info({
                    title: 'Tip',
                    message: 'Preparing your download. This may take a few minutes.Please do not click repeatedly',
                    offset: 100,
                    duration: 0
                });
                const link = document.createElement("a");
                link.href = URL.createObjectURL(this.pdfBlob);
                link.download = "Companyprofile.pdf";
                link.click();
                URL.revokeObjectURL(link.href); // 释放 URL 对象
                setTimeout(() => {
                    this.isDownloading = false;
                }, 5000);
            }
        },
    },
    mounted() {
        this.preloadPdf(); // 组件挂载时预加载 PDF
    }
};
</script>
<style scoped>
.wrapper {
    width: 100vw;
    margin: 0 auto 23.733vw;
}

.down {
    margin-top: 12.267vw;
    padding: 0 7.733vw;
}

::v-deep .el-button--danger {
    color: #FFF;
    background-color: #CA141D;
    border-color: #CA141D;
    width: 100%;
    border-radius: 5px;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
}
</style>